module.exports = __webpack_public_path__ + "img/edge_divers_producteur_local.d9d37560.svg";